module.exports = __webpack_public_path__ + "static/img/chair_zhenxin_max.b44baa10.png";